import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import Songs from './Song/Songs';
import Search from './Song/Search';
import Summary from './Summary';
import Recommendations from './Recommendation/Recommendations';
import Import from './Import/';

export default class Playlist extends React.Component {
  static propTypes = {
    playlist: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    searchResults: PropTypes.array.isRequired,
    showControls: PropTypes.bool,
    refetchSearchResults: PropTypes.func.isRequired,
    editable: PropTypes.bool,
    fillable: PropTypes.bool,
    goBack: PropTypes.func,
    removeFromPlaylist: PropTypes.func,
    updatePlaylist: PropTypes.func,
    updateMaxLength: PropTypes.func,
    deletePlaylist: PropTypes.func,
    playlistContainsSong: PropTypes.func.isRequired,
    addToPlaylist: PropTypes.func.isRequired,
    addPlaylistRecommendations: PropTypes.func,
    removePlaylistRecommendation: PropTypes.func,
    viewer: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.listRef = React.createRef();
    this.importSpotifyRef = React.createRef();
    this.createNewSong = this.createNewSong.bind(this);
  }

  createNewSong(e) {
    this.createPlannerPlaylistSong(
      e,
      this.state.newSong,
      this.props.playlist,
      this.closeNewSongForm
    );
  }

  render() {
    const {
      playlist,
      editable,
      fillable,
      goBack,
      addToPlaylist,
      addPlaylistRecommendations,
      removePlaylistRecommendation,
      playlistContainsSong,
      removeFromPlaylist,
      relay,
      refetchSearchResults,
      searchResults,
      showControls,
      updatePlaylist,
      updateMaxLength,
      deletePlaylist,
      viewer
    } = this.props;

    return (
      <Grid stretched centered>
        <Grid.Row>
          <Grid.Column computer={16} tablet={16} mobile={16}>
            <Summary
              playlist={playlist}
              editable={editable}
              goBack={goBack}
              showControls={showControls}
              updatePlaylist={updatePlaylist}
              updateMaxLength={updateMaxLength}
              deletePlaylist={deletePlaylist}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row
          style={{ marginTop: 0 }}
          verticalAlign='top'
        >
          <Grid.Column computer={16} tablet={16} mobile={16}>
            {fillable &&
              <div style={{ display: 'flex', marginBottom: '1em', alignItems: 'center' }}>
                <div style={{ flex: 1, marginRight: '0.5em' }}>
                  <Search
                    searchResults={searchResults}
                    refetchSearchResults={refetchSearchResults}
                    addToPlaylist={addToPlaylist}
                    playlistContainsSong={playlistContainsSong}
                    playlist={playlist}
                    clearSearch={() => {}}
                    listRef={this.listRef}
                  />
                </div>
                <div><Import addToPlaylist={addToPlaylist} importSpotifyRef={this.importSpotifyRef} /></div>
              </div>}
            <Songs
              playlist={playlist}
              innerRef={this.listRef}
              importSpotifyRef={this.importSpotifyRef}
              removeFromPlaylist={fillable ? removeFromPlaylist : null}
            />
            {playlist.playlist_recommendations &&
              (editable || playlist.playlist_recommendations.edges.length > 0) &&
              <Recommendations
                addPlaylistRecommendations={addPlaylistRecommendations}
                removePlaylistRecommendation={removePlaylistRecommendation}
                playlistRecommendations={
                  playlist.playlist_recommendations.edges
                }
                viewer={viewer}
                relay={relay}
                editable={editable}
                addToPlaylist={addToPlaylist}
                playlist={playlist}
                playlistContainsSong={playlistContainsSong}
              />}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Playlist/index.js